import { generatePaletteTexture } from "./paletteTexture";
import WebglProgram from "./webglProgram";

export default class PaletteWebglProgram extends WebglProgram {
  constructor(vert, frag){
    super(vert, frag);

    this.paletteTexture = null;
    this.palette = null;
    this.paletteLocation = null;
  }

  prepareLocations(gl){
    super.prepareLocations(gl);
    this.paletteLocation = gl.getUniformLocation(this.program, "u_palette");
  }

  setSamplerLocation(gl, imageTexture) {
    super.setSamplerLocation(gl, imageTexture);
    gl.uniform1i(this.paletteLocation, 1);
    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, this.paletteTexture);
  }

  setPalette(gl, palette){
    if (palette !== this.palette) {
      this.palette = palette;
      this.paletteTexture = generatePaletteTexture(gl, palette);
    }
  }

  setOCTColorSettings(gl, octColorSettings){
    if (octColorSettings.colorPalette) this.setPalette(gl, octColorSettings.colorPalette);
  }

  setThicknessMapColorSettings(gl, thicknessMapColorSettings){
    this.setPalette(gl, thicknessMapColorSettings.colorPalette);
  }
}